import client from '../axios';

interface IGetAccountStatusRequest {
  month: string;
  year: string;
  type: string;
  country: string;
  language: string;
}

export interface IGetAccountStatusRequestV2 {
  startDate: string;
  endDate: string;
  enterpriseId: string;
  language: string;
}

interface IGetInvoiceDateRequest {
  firstDate: string | undefined | null;
  secondDate: string | undefined | null;
  country: string;
  language: string;
}

interface IGetStatusResponse extends IGetAccountStatusRequest {
  url?: string;
}

interface IGetInvoiceResponse extends IGetInvoiceDateRequest {
  url?: string;
}

const reportAccountStatus = async ({
  month,
  year,
  type,
  country,
  language,
}: IGetAccountStatusRequest): Promise<IGetStatusResponse> => {
  const reportData = {
    month,
    year,
    type,
    country,
    language,
  };

  let urlPost = 'invoice-generator/';
  if (type === 'btnExcel') {
    urlPost = 'account-status-xls/';
  }

  return client.post(urlPost, reportData, {
    isAuthRedirect: false,
  });
};

const reportAccountStatusPDF = async ({
  startDate,
  endDate,
  enterpriseId,
  language,
}: IGetAccountStatusRequestV2): Promise<Blob> => {
  const endpoint = `enterprise/${enterpriseId}/statement/pdf/`;

  try {
    const response = await client.get(endpoint, {
      headers: { 'Content-Type': 'application/json' },
      params: { start_date: startDate, end_date: endDate, language },
      responseType: 'blob',
      isAuthRedirect: false,
    });

    return response;
  } catch (error) {
    console.error('Error call endpoint:', error);
    throw new Error(
      error instanceof Error ? error.message : 'An unexpected error occurred.'
    );
  }
};

const reportInvoiceDate = async ({
  firstDate,
  secondDate,
  country,
  language,
}: IGetInvoiceDateRequest): Promise<IGetInvoiceResponse> => {
  const reportData = {
    firstDate,
    secondDate,
    country,
    language,
  };

  return client.post('invoice-date-download/', reportData, {
    isAuthRedirect: false,
  });
};

const accountstatusSvc = {
  reportAccountStatus,
  reportInvoiceDate,
  reportAccountStatusPDF,
};

export default accountstatusSvc;
